import Vue from 'vue';
import BravadoNav from '@bravado-network/nav';

Vue.use(BravadoNav);
